// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div>\n  <ol class=\"index data\">\n    <li inject=\"document-list-inject-spot\"></li>\n  </ol>\n</div>\n";
},"useData":true});
